import * as React from 'react';
import { Link } from 'react-router-dom';
import { Routes } from 'constants/pages';
import { OutstandingFeesBreakdown } from 'services/clients/insights';
import { buildSearchParams } from 'common/hooks/customSearchParams/customSearchParams';
import { SHIPMENTS_QUERY_PARAMS } from 'pages/Shipments/params';
import { CurrentContainerStatus } from 'types/Watchlist';

export const getParamsForView = (label: string, key: string, view: OutstandingFeesBreakdown) => {
  switch (view) {
    case OutstandingFeesBreakdown.Container: {
      const containerNumber = label;
      return { containerNumbers: [containerNumber] };
    }
    case OutstandingFeesBreakdown.OceanBOL: {
      const bol = label;
      return { billOfLadingNumbers: [bol] };
    }
    case OutstandingFeesBreakdown.ShippingLine: {
      const shippingLine = key;
      return { shippingLine: [shippingLine], containerStatus: [CurrentContainerStatus.GatedOut] };
    }
    case OutstandingFeesBreakdown.Port: {
      const port = key;
      return { portPickupCodes: [port], containerStatus: [CurrentContainerStatus.GatedOut] };
    }
    case OutstandingFeesBreakdown.Terminal: {
      const terminal = key;
      return { terminalPickupKeys: [terminal], containerStatus: [CurrentContainerStatus.GatedOut] };
    }
    default:
      return null;
  }
};

export const linkFromParams = (
  label: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  params?: any
) => {
  if (!params) {
    return label;
  }

  const searchParams = buildSearchParams(SHIPMENTS_QUERY_PARAMS, params);
  const to = `${Routes.ShipmentsActive}?${new URLSearchParams(searchParams).toString()}`;
  return (
    <Link to={to} className="underline">
      {label}
    </Link>
  );
};
